import { useEffect } from "react";
import {
  DataTable, EmptyRow, Prompt, Screen, StatusDot, type Column,
  LoadError,
}  from "../components/primitives";
import { useConsoleStore } from "../stores/consoleStore";
import { useUiStore } from "../stores/uiStore";
import { useWorkspaceStore } from "../stores/workspaceStore";
import type { Job } from "../types/domain";

const COLUMNS: Column[] = [
  { key: "id", label: "job", width: "1fr" },
  { key: "kind", label: "kind", width: "1fr" },
  { key: "namespace", label: "namespace", width: "2fr" },
  { key: "status", label: "status", width: "0.9fr" },
];

export default function Jobs() {
  const openDetail = useUiStore((s) => s.openDetail);
  const workspaceId = useWorkspaceStore((s) => s.currentId);
  const jobs = useConsoleStore((s) => s.jobs);
  const loadError = useConsoleStore((s) => s.errors.jobs);
  const load = useConsoleStore((s) => s.loadJobs);

  useEffect(() => {
    if (workspaceId) void load();
  }, [workspaceId, load]);

  return (
    <Screen>
      <Prompt command="vf jobs ls --all" />
      <LoadError message={loadError} />

      <DataTable<Job>
        fontSize="12.5px"
        columns={COLUMNS}
        rows={jobs}
        rowKey={(j) => j.id}
        onRowClick={(j) => openDetail("job", j.id)}
        empty={
          <EmptyRow
            title="no jobs yet"
            body="Clone, reindex, compaction and webhook-triggered push jobs appear here with their live progress."
          />
        }
        note={
          jobs.length > 0
            ? "// queued reindex/compact jobs can be canceled; webhook-triggered push jobs are durable ingest work"
            : undefined
        }
        renderCell={(j, key) => {
          switch (key) {
            case "id":
              return <span style={{ color: "var(--vf-acc)" }}>{j.id}</span>;
            case "kind":
              return <span style={{ color: "var(--vf-text)" }}>{j.kind}</span>;
            case "namespace":
              return <span style={{ color: "var(--vf-sec)" }}>{j.namespace}</span>;
            case "status":
              return <StatusDot status={j.status} />;
            default:
              return null;
          }
        }}
      />
    </Screen>
  );
}
